import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";
import {
  AddGDORMasterDetail,
  DeleteGDORMasterDetail,
  GetAllGDORMasterDetailwithPagging,
  UpdateGDORMasterDetail,
} from "../../../../api/User/ACG/GDORMasterDetailApi";

const schema = Yup.object().shape({
  zip: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter zip"),
  relativePriceScore: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter relative price score"),
  iMUScore: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter IMU score"),
  hPSAScore: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter HPSA score"),
  opioidConcern: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter opioid concern"),
  aDIScore: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ADI score"),
});

const GDORMasterDetail = () => {
  const [showTable, setShowTable] = useState(true);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const buttonRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const column = [
    { title: "Zip", field: "zip" },
    { title: "Relative Price Score", field: "relative_Price_Score" },
    { title: "IMU Score", field: "imU_Score" },
    { title: "HPSA Score", field: "hpsA_Score" },
    { title: "Opioid Concern", field: "opioid_Concern" },
    { title: "ADI Score", field: "adI_Score" },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
  }, [showModal]);

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    const {
      zip,
      relativePriceScore,
      iMUScore,
      hPSAScore,
      opioidConcern,
      aDIScore,
    } = values;
    const payload = {
      id: 0,
      zip: zip,
      relative_Price_Score: +relativePriceScore,
      imU_Score: +iMUScore,
      hpsA_Score: +hPSAScore,
      opioid_Concern: +opioidConcern,
      adI_Score: +aDIScore,
    };

    if (witchAction === "add") {
      setShowTable(false);
      AddGDORMasterDetail(payload)
        .then((res) => {
          if(res.status === 200 || res.status === 204){
          toastFile("new");
          setShowModal(false);
          }
        })
        .finally((res) => setShowTable(true));
    } else if (witchAction === "update") {
      setShowTable(false);
      UpdateGDORMasterDetail({
        ...payload,
        id: selectedRowData.id,
      })
        .then((res) => {
          if(res.status === 200 || res.status === 204){
          toastFile("update");
          setShowModal(false);
          }
        })
        .finally((res) => setShowTable(true));
    }
  };
  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            GDOR Master detail
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                setShowTable(false);
                DeleteGDORMasterDetail(selectedRowData?.id)
                  .then((res) => {
                    if(res.status === 200 || res.status === 204){
                    toastFile("delete");
                    setShowModal(false);
                    }
                  })
                  .finally((res) => setShowTable(true));
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                zip: selectedRowData?.zip,
                relativePriceScore: selectedRowData?.relative_Price_Score ?? 0,
                iMUScore: selectedRowData?.imU_Score ?? 0,
                hPSAScore: selectedRowData?.hpsA_Score ?? 0,
                opioidConcern: selectedRowData?.opioid_Concern ?? 0,
                aDIScore: selectedRowData?.adI_Score ?? 0,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-2 gap-3">
                    <CustomInputField
                      label="Zip"
                      name="zip"
                      maxLength={5}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                    <CustomInputField
                      label="Relative Price Score"
                      name="relativePriceScore"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                    <CustomInputField
                      label="IMU Score"
                      name="iMUScore"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                    <CustomInputField
                      label="HPSA Score"
                      name="hPSAScore"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                    <CustomInputField
                      label="Opioid Concern"
                      name="opioidConcern"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                    <CustomInputField
                      label="ADI Score"
                      name="aDIScore"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                  </Row>
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success">
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add New GDOR Master detail
        </CustomButton>
      </div>
      {showTable && (
        <CustomMaterialTable
        isExport={true}
          column={column}
          data={(query) =>
            new Promise((resolve, reject) => {
              GetAllGDORMasterDetailwithPagging(
                query.page,
                query.pageSize,
                query.search
              ).then((result) => {
                resolve({
                  data: result.data.gdorMasterDetails,
                  page: query.page,
                  totalCount: result.data.totalPages * query.pageSize,
                });
              });
            })
          }
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          setWitchAction={setWitchAction}
          setSelectedRowData={setSelectedRowData}
          setShowModal={setShowModal}
        />
      )}
    </div>
  );
};

export default GDORMasterDetail;
